import { Icon } from "@iconify/react"
import { Card, Flex, Input, message, Pagination, Table, Tag } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import useTitleStore from "../../store/titleStore";
import useDebounce from "../../hooks/useDebounce";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTableHeight } from "../../hooks/useTableHeight";
import { format } from 'date-fns';
import TableAction from "../../components/TableAction";
import { contactService } from "../../services/contact.service";

export default function ContactIndex(){

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const queryClient = useQueryClient();
  const tableHeight = useTableHeight();
  
  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['contacts', dataParams],
    queryFn: () => contactService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => contactService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('contacts');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  useEffect(() => {
    setTitle("Kontak");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'name',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      fixed: 'left'
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      width: 210,
      fixed: 'left'
    },
    {
      title: 'ID Pelanggan',
      dataIndex: 'customer_id',
      width: 150
    },
    {
      title: 'Jenis Layanan',
      dataIndex: 'type',
      width: 210,
      render: val => {
        if(val == 'Pertanyaan'){
          return <Tag color="yellow" >Pertanyaan</Tag>
        }
        return <Tag color="blue" >Informasi</Tag>
      }
    },
    {
      title: 'Tanggal Aduan',
      dataIndex: 'createdAt',
      width: 180,
      render: val => format(new Date(val), 'EEEE, dd-MM-yyyy')
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => navigate('/contact/detail/'+record.id)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
        />
      )
    },
  ]



  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      <Flex justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
      </Flex>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={informationData?.data}
      />
       <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={informationData?.pagination?.total}
          pageSizeOptions={['10', '20', '50']}
          current={informationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
          showSizeChanger={{
            showSearch: false,
          }}
        />
    </Card>
  )
}